import React from 'react';
import { Typography } from '@mui/material';

export default function PersonalData() {
    return (
        <Typography variant="h5">
            Datos Personales
        </Typography>
    );
}
